import { ApiType } from "@gymflow/common";
import { ProductOrderDetailDTO } from "@gymflow/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { appointmentAsMemberQueryKeys } from "../appointmentAsMember";
import { productAsMemberQueryKeys } from "../productAsMember";
import { memberAsMemberQueryKeys } from "./memberAsMemberQueryKeys";

export function useMutationMemberSaleAsMember({
  api,
}: {
  api: ApiType;
  clubId: number;
}) {
  const queryClient = useQueryClient();
  const result = useMutation({
    mutationFn: async (
      params: {
        idempotencyKey: string;
        paymentMethod?: string;
        promotionCode?: string;
        walletAmount?: number;
      } & (
        | {
            startDate: string;
            membershipId: number;
          }
        | {
            startDate: string;
            sessionPackId: number;
          }
        | {
            products: ProductOrderDetailDTO[];
          }
      ),
    ) => {
      if ("products" in params) {
        return (
          await api.customerProductApi.order(
            {
              paymentMethodId: params.paymentMethod,
              promotionCode: params.promotionCode,
              orderItems: params.products,
              walletAmount: params.walletAmount,
            },
            params.idempotencyKey,
          )
        ).data;
      } else if ("sessionPackId" in params) {
        return (
          await api.profileApi.checkoutSessionPack(
            {
              paymentMethodId: params.paymentMethod,
              promotionCode: params.promotionCode,
              sessionPackId: params.sessionPackId,
              startDate: params.startDate,
              walletAmount: params.walletAmount,
            },
            params.idempotencyKey,
          )
        ).data;
      } else {
        return (
          await api.profileApi.checkoutMembership(
            {
              paymentMethodId: params.paymentMethod,
              promotionCode: params.promotionCode,
              membershipId: params.membershipId,
              startDate: params.startDate,
              walletAmount: params.walletAmount,
            },
            params.idempotencyKey,
          )
        ).data;
      }
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: memberAsMemberQueryKeys.all(),
      });
      queryClient.invalidateQueries({
        queryKey: productAsMemberQueryKeys.all(),
      });
      queryClient.invalidateQueries({
        queryKey: appointmentAsMemberQueryKeys.all(),
      });
    },
  });

  return result;
}
